import * as React from "react";
import Button from "@mui/material/Button";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

import { BORDER_COLORS } from "../../../constants";

interface IShowAllFilterProps {
  isShowAll: boolean;
  onChange: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ShowAllFilter: React.FC<IShowAllFilterProps> = ({
  isShowAll,
  onChange,
}) => {
  const toggleShowAll = () => {
    onChange(!isShowAll);
  };

  return (
    <Button
      variant="outlined"
      color="default"
      onClick={toggleShowAll}
      sx={{ height: "40px", borderColor: BORDER_COLORS.main }}
    >
      {!isShowAll ? (
        <>
          Show all details
          <ArrowDropDownIcon sx={{ fontSize: 18, color: "#3D3D3D" }} />
        </>
      ) : (
        <>
          Hide all details
          <ArrowDropUpIcon sx={{ fontSize: 18, color: "#3D3D3D" }} />
        </>
      )}
    </Button>
  );
};

export default ShowAllFilter;
